import React from 'react'
import "../Footwear.js/ProductsWomenFootwear.css";
import f1 from "../assets/f1.jpg";
import f2 from "../assets/f2.jpg";
import f3 from "../assets/f3.jpg";
import f4 from "../assets/f4.jpg";
import f5 from "../assets/f5.jpg";
import f6 from "../assets/f6.jpg";

export default function ProductsWomenFootwear() {

    const productsWomenFootwear = [
  {
    id: 1,
    name: "Model No.MS-725-31",
    description: "Premium leather, modern fit, soft inner lining.",
    image: f1,
    link: "/products/womens-footwear1",
  },
  {
    id: 2,
    name: "Model No.MS-725-32",
    description: "Premium leather, modern fit, soft inner lining.",
    image: f2,
    link: "/products/womens-footwear2",
  },
  {
    id: 3,
    name: "Model No.MS-725-33",
    description: "Premium leather, modern fit, soft inner lining.",
    image: f3,
    link: "/products/womens-footwear3",
  },
  {
    id: 4,
    name: "Model No.MS-725-34",
    description: "Premium leather, modern fit, soft inner lining.",
    image: f4,
    link: "/products/womens-footwear4",
  },
  {
    id: 5,
    name: "Model No.MS-725-35",
    description: "Premium leather, modern fit, soft inner lining.",
    image: f5,
    link: "/products/womens-footwear5",
  },
  {
    id: 6,
    name: "Model No.MS-725-36",
    description: "Premium leather, modern fit, soft inner lining.",
    image:f6,
    link: "/products/womens-footwear6",

  },

  
];
  return (
    <>
       <section className="pwf">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Women’s Footwear</h1>
      <div className="pwf__grid">
        {productsWomenFootwear.map((p) => (
          <article key={p.id} className="pwf__card">
            <img className="pwf__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="pwf__name">{p.name}</h3>
            {/* <p className="pwf__desc">{p.description}</p> */}
            <a className="pwf__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>

    </>
  )
}
